import React, { useState } from 'react';
import { ref, push } from 'firebase/database';
import { db } from '../firebase';
import { Application } from '../types';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const HERO_IMG = 'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=1800&q=85&fit=crop';

const programs = [
  'Software Engineering', 'Computer Science', 'Artificial Intelligence & Data Science',
  'Electrical & Electronic Engineering', 'Industrial Engineering', 'Mechanical Engineering',
  'Environmental Engineering', 'Naval Architecture & Marine Engineering', 'Architecture',
  'Interior Architecture', 'Business Management', 'Global Trade & Logistics', 'Economics',
  'Accounting & Finance', 'Marketing', 'Entrepreneurship & Innovation',
  'Human Resource Management', 'Psychology', 'Political Science & International Relations',
  'Sociology', 'Philosophy', 'Legal Studies', 'Educational Sciences', 'Child Development',
  'Healthcare Administration', 'Nutrition & Dietetics', 'Physiotherapy & Rehabilitation',
  'Biotechnology', 'Biomedical Engineering',
];

const Apply: React.FC = () => {
  const [form, setForm] = useState({ fullName: '', email: '', phone: '', country: '', program: '', degree: '', message: '' });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) =>
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const data: Application = { ...form, createdAt: Date.now(), status: 'new' };
      await push(ref(db, 'applications'), data);
      setDone(true);
    } catch {
      setError('An error occurred. Please try again or contact us directly at info@uaa.education.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="form-page">
        <div
          className="form-hero"
          style={{
            backgroundImage: `linear-gradient(160deg, rgba(4,15,30,0.88) 0%, rgba(11,37,69,0.82) 100%), url(${HERO_IMG})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center top',
          }}
        >
          <span style={{ fontFamily: "'Segoe UI', system-ui, sans-serif", fontSize: '0.7rem', fontWeight: 700, letterSpacing: '2.5px', textTransform: 'uppercase', color: 'rgba(184,150,46,0.8)', display: 'block', marginBottom: 12 }}>Admissions</span>
          <h1>Application for Admission</h1>
          <p>Complete the form below. Our admissions office will review your application and contact you within 3–5 business days.</p>
        </div>
        <div className="form-body">
          {done ? (
            <div className="success-msg">
              <div className="success-icon">
                <svg viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              <h2>Application Submitted Successfully</h2>
              <p>Thank you for applying to the University of American Atlantic. Our admissions team will review your application and contact you at the email address provided within 3–5 business days.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="form-section-title">Personal Information</div>
              <div className="form-grid">
                <div className="form-group">
                  <label>Full Name *</label>
                  <input name="fullName" required value={form.fullName} onChange={handleChange} placeholder="As it appears on your passport" />
                </div>
                <div className="form-group">
                  <label>Email Address *</label>
                  <input name="email" type="email" required value={form.email} onChange={handleChange} placeholder="your@email.com" />
                </div>
                <div className="form-group">
                  <label>Phone Number</label>
                  <input name="phone" value={form.phone} onChange={handleChange} placeholder="+1 (555) 000-0000" />
                </div>
                <div className="form-group">
                  <label>Country of Residence *</label>
                  <input name="country" required value={form.country} onChange={handleChange} placeholder="e.g. United States" />
                </div>
              </div>

              <div className="form-section-title" style={{ marginTop: 28 }}>Academic Preferences</div>
              <div className="form-grid">
                <div className="form-group">
                  <label>Desired Program *</label>
                  <select name="program" required value={form.program} onChange={handleChange}>
                    <option value="">Select a program</option>
                    {programs.map(p => <option key={p} value={p}>{p}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Degree Level *</label>
                  <select name="degree" required value={form.degree} onChange={handleChange}>
                    <option value="">Select degree level</option>
                    <option value="bachelor">Bachelor's Degree</option>
                    <option value="master">Master's Degree</option>
                    <option value="doctorate">Doctoral Degree</option>
                  </select>
                </div>
                <div className="form-group full">
                  <label>Additional Information</label>
                  <textarea name="message" value={form.message} onChange={handleChange} placeholder="Please describe your academic background, professional experience, or any specific questions regarding your application." />
                </div>
              </div>

              {error && <p style={{ fontFamily: "'Segoe UI', system-ui, sans-serif", color: '#dc2626', fontSize: '0.85rem', marginTop: 12 }}>{error}</p>}

              <div className="form-submit">
                <button className="btn-submit" type="submit" disabled={loading}>
                  {loading ? 'Submitting Application...' : 'Submit Application'}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Apply;
